import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Select from 'react-select';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';
import FormAssistanceVehicle from './assistanceVehicles';
import AssistanceVehicleFields from './assistanceVehicleFields';


function NewAssistanceVehicle() {
    const navigate = useNavigate();
    const { Formik } = formik;


    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/catalogs/assistanceVehicles">Vehículos de asistencia</Link></li>
                        <li className="breadcrumb-item active">Nuevo Vehículos de asistencia</li>
                    </ol>
                    <h1 className="page-header mb-0">Registro de nuevo Vehículos de asistencia</h1>
                </div>
            </div>



            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Registro de nuevo Vehículos de asistencia</PanelHeader>
                        <PanelBody>
                            <Formik
                                validationSchema={yup.object().shape({
                                    vehicle_type_id: yup.object().required("Selecciona o registra un tipo de vehículo"),
                                    brand_id: yup.object().required("Selecciona o registra una marca de vehículo"),
                                    vehicle_model_id: yup.object().required("Selecciona o registra un modelo de vehículo"),
                                    anio: yup.object().required('Selecciona un año'),
                                    placas: yup.string().required('El número de placa es obligatorio'),
                                    numero_serie: yup.string().required('El número de serie es obligatorio'),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);
                                   // console.log("values a enviar", values);
                                    axiosClient.post('/assistanceVehicles/save', values).then(response => {
                                        Swal.fire({
                                            title: 'Registro exitoso.',
                                            text: 'Se ha registrado el nuevo Vehículo de asistencia',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                        navigate('/catalogs/assistanceVehicles');
                                    }).catch(err => {
                                       // console.log(err);

                                        let message = err.response.data.message;

                                        Swal.fire({
                                            title: 'Ups!',
                                            text: message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                    });
                                }}
                                initialValues={{
                                    vehicle_type_id: '',
                                    brand_id: '',
                                    vehicle_model_id: '',
                                    anio: '',
                                    placas: '',
                                    numero_serie: ''
                                }}
                            >
                                {({ handleSubmit, handleChange, values, setFieldValue, errors, touched, setFieldTouched }) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <AssistanceVehicleFields
                                            values={values}
                                            handleChange={handleChange}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            touched={touched}
                                            setFieldTouched={setFieldTouched}
                                        />



                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar Vehículo de asistencia</Button>{' '}
                                                <Link to={'/catalogs/assistanceVehicles'} className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>

                        </PanelBody>
                    </Panel>
                </div>

            </div>


        </div>

    );
}

export default NewAssistanceVehicle;